<template>
    <div :class="field.classes">
         <label class="checkbox-label with-flexible-parts mt-0" >
            <input
                class="checkbox flexible-part" type="checkbox"
                :name="field.name"  
                :id="field.name"
                :value="value"
                @change="update"
                :class="inputClass"
                 >        
            <div class="checkbox-box lw-brand-border flexible-part">
                <span class="learnworlds-icon learnworlds-heading3-small fas fa-check"></span>
            </div>
            <div class="flexible-part">
                <div class="learnworlds-main-text  learnworlds-main-text-small learnworlds-element">
                    <span class="lnd-form-link-lbl">
                    {{ name }}
                    </span>
                    <a href="javascript:void(0)" ref="termsLink" class="lnd-form-link">
                        {{ i18n.get(field.translationKeyLink) }}
                    </a>                
                </diV>
            </div>
        </label>
        <div v-if="error" class="learnworlds-main-text learnworlds-main-text-small learnworlds-element lw-brand-text">
        {{ error }}
        </div>        
    </div>
</template>

<script>
    import FieldMixin from "./FieldMixin";
    
    export default {
        name: "TermsComponent",

        mixins: [
            FieldMixin
        ],
        mounted(){
            this.initTermsModal();
        },
        methods: {
            update(e) {            
                this.$emit('input', event.target.checked);
            },
            initTermsModal(){
                $(this.$refs['termsLink']).fancybox({
                    "type":"iframe",
                    fitToView: false,
                    autoSize: false,
                    autoDimensions: false,
                    "height": "80%",
                    "href":"/pages/terms",
                    afterLoad:function(){
                        var $pageWrapperClone = $('body',$('.fancybox-iframe').contents())
                            .find('#pageContent').clone();
                        $pageWrapperClone.find('.lw-topbar, .lw-footer').hide();
                        $('body',$('.fancybox-iframe').contents())
                            .find("*").remove();
                        $('body',$('.fancybox-iframe').contents())
                            .append($pageWrapperClone);

                    },
                });
            } 
        }
    }
</script>
